import React from 'react'
import LineMoneyBillSlashIcon from 'LuxKit/Icons/line/LineMoneyBillSlashIcon'
import LineSmileIcon from 'LuxKit/Icons/line/LineSmileIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import { formatRoundedAmountWithDollarType } from 'lib/format/formatCurrencyIntl'
import { getAtomeBpMaxLimit } from 'lib/payment/atomeBpUtils'

export const StepsHowItWorks = [
  {
    image: <LineCalendarIcon size="XL" />,
    title: 'Pay in three instalments',
    description: 'Pay your first instalment at the time of purchase and the rest in 2 equal, 30-day instalments.',
  },
  {
    image: <LineMoneyBillSlashIcon size="XL" />,
    title: 'No hidden fees or charges, ever',
    description: 'The only fees are for late payments. But don’t worry, Atome will send you regular reminders.',
  },
  {
    image: <LineSmileIcon size="XL" />,
    title: 'No minimum spend',
    description: 'Get what you need, when you need it, without any minimum spend.',
  },
]

export const getStepsBuyNow = (currency: string, regionCode: string) => {
  return [
    {
      title: '1',
      description: 'Browse your favourite escapes',
    },
    {
      title: '2',
      description: `Select Atome as your payment method for purchases of ${formatRoundedAmountWithDollarType(getAtomeBpMaxLimit(currency), currency, regionCode)} and under`,
    },
    {
      title: '3',
      description: 'Instantly create an account or login and pay your first instalment at the time of purchase',
    },
  ]
}

export const getTermsAndConditionsUrlLink = (currency: string) => {
  switch (currency) {
    case 'SGD':
      return 'https://www.atome.sg/terms-of-service'
    case 'MYR':
      return 'https://www.atome.my/en-my/terms-of-service'
    case 'HKD':
      return 'https://www.atome.hk/terms-of-service'
    default:
      return 'https://www.atome.sg/terms-of-service'
  }
}
